module.exports = __webpack_public_path__ + "static/media/logo.2529b5f4.png";